// extracted by mini-css-extract-plugin
export default {"checkboxLabelTooltips":"DP0KBG328aJEe1AhabwE"};